
// Global Organization Switcher.

window.addEventListener('load', () => {
  tangibleFields.event('valueChange', field => {
    if ( field.name === 'membersync_global_organization_switcher' ) {
      const url = restUrl + '/wp-json/membersync/licensing/v1/organization/global/set'
      const nonce = restNonce

      fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          'org': field.value
        }),
        headers:{
          'X-WP-Nonce': nonce,
          'Content-type': 'application/json'
        }
      })

      const productOrgSelected = tangibleFields?.store?.getValue('membersync_orgs_select_org')
      if ( productOrgSelected.org ) {
        productOrgSelected.org = field.value
        tangibleFields?.store?.setValue('membersync_orgs_select_org', productOrgSelected)
      }
    }
  })
})
